
  import classNames from 'classnames'
  import React from 'react'
  import styles from '../NamedIcon.module.scss'
  import IconHoC from '../NamedIconHoC'
  import type { NamedIconPropsType } from '../types'
  
  export const BarsIcon: React.FC<NamedIconPropsType> = ({className, rtl = false, outline = false, ...props  }) => {
    let Foreground,
      Background = null
    if (!rtl) {
      Foreground = <svg className={styles['pintxo-icon__foreground']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8 23.5C8 21.567 9.567 20 11.5 20H84.5C86.433 20 88 21.567 88 23.5C88 25.433 86.433 27 84.5 27H11.5C9.567 27 8 25.433 8 23.5Z" fill="#161617"/>
<path d="M8 72.5C8 70.567 9.567 69 11.5 69H84.5C86.433 69 88 70.567 88 72.5C88 74.433 86.433 76 84.5 76H11.5C9.567 76 8 74.433 8 72.5Z" fill="#161617"/>
<path d="M11.5 44.5C9.567 44.5 8 46.067 8 48C8 49.933 9.567 51.5 11.5 51.5H84.5C86.433 51.5 88 49.933 88 48C88 46.067 86.433 44.5 84.5 44.5H11.5Z" fill="#161617"/>
</svg>

      Background = !outline && <svg className={styles['pintxo-icon__background']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8 23.5C8 21.567 9.567 20 11.5 20H84.5C86.433 20 88 21.567 88 23.5C88 25.433 86.433 27 84.5 27H11.5C9.567 27 8 25.433 8 23.5Z" fill="#F2F2F3"/>
<path d="M8 72.5C8 70.567 9.567 69 11.5 69H84.5C86.433 69 88 70.567 88 72.5C88 74.433 86.433 76 84.5 76H11.5C9.567 76 8 74.433 8 72.5Z" fill="#F2F2F3"/>
<path d="M11.5 44.5C9.567 44.5 8 46.067 8 48C8 49.933 9.567 51.5 11.5 51.5H84.5C86.433 51.5 88 49.933 88 48C88 46.067 86.433 44.5 84.5 44.5H11.5Z" fill="#F2F2F3"/>
</svg>

    } else {
      Foreground = <svg className={styles['pintxo-icon__foreground']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8 23.5C8 21.567 9.567 20 11.5 20H84.5C86.433 20 88 21.567 88 23.5C88 25.433 86.433 27 84.5 27H11.5C9.567 27 8 25.433 8 23.5Z" fill="#161617"/>
<path d="M8 72.5C8 70.567 9.567 69 11.5 69H84.5C86.433 69 88 70.567 88 72.5C88 74.433 86.433 76 84.5 76H11.5C9.567 76 8 74.433 8 72.5Z" fill="#161617"/>
<path d="M11.5 44.5C9.567 44.5 8 46.067 8 48C8 49.933 9.567 51.5 11.5 51.5H84.5C86.433 51.5 88 49.933 88 48C88 46.067 86.433 44.5 84.5 44.5H11.5Z" fill="#161617"/>
</svg>

      Background = !outline && <svg className={styles['pintxo-icon__background']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8 23.5C8 21.567 9.567 20 11.5 20H84.5C86.433 20 88 21.567 88 23.5C88 25.433 86.433 27 84.5 27H11.5C9.567 27 8 25.433 8 23.5Z" fill="#F2F2F3"/>
<path d="M8 72.5C8 70.567 9.567 69 11.5 69H84.5C86.433 69 88 70.567 88 72.5C88 74.433 86.433 76 84.5 76H11.5C9.567 76 8 74.433 8 72.5Z" fill="#F2F2F3"/>
<path d="M11.5 44.5C9.567 44.5 8 46.067 8 48C8 49.933 9.567 51.5 11.5 51.5H84.5C86.433 51.5 88 49.933 88 48C88 46.067 86.433 44.5 84.5 44.5H11.5Z" fill="#F2F2F3"/>
</svg>

    }
    return <IconHoC rtl={rtl} outline={outline} className={classNames(styles['pintxo-icon'], className)} {...props}>
      {Foreground && Foreground}
      {Background && Background}
    </IconHoC>
  }
  
